<template>
	<div>
		<p><b>סה"כ:</b> {{payload.data.income.display_text}} (מספר השמות: {{ payload.data.offers.length }})</p>
		<search-modal-applicants :results="payload.data.offers" :show_recruiters="true"></search-modal-applicants>
	</div>
</template>
<script>
	import SearchModalApplicants from '@/components/SearchModalApplicants'
	export default {
		name: 'report-month-offers',
		props: ['payload'],
		components: {
			SearchModalApplicants
		}
	}
</script>